module.exports = __webpack_public_path__ + "static/media/Payment System Logo.a07fb601.svg";